// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"626f5e6b","732":"c429e709"}[chunkId] + ".chunk.js";
};